module.exports = __webpack_public_path__ + "media/images/logo-mobile-a424333a7b4c16b040b048802e40702a.svg";